export const CheckmarkOutline = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.69096 15.7127L13.9886 20.0104L22.3032 11.6962" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
</svg>`;
